import React from 'react';
import SongLinks from './SongLinks';
import cover from "../assets/coverart/Maschinen.jpg"


export const Maschinen = () => {    

    return (
        <SongLinks 
        title={"Maschinen"} 
        coverArt={cover} 
        spotifyLink={"https://open.spotify.com/album/3NTZzprVJOcPt8bfmQ11zi"}
        spotifyPresaveLink={"https://add-it.feiyr.com/MondWild/Maschinen"}
        appleMusicLink={"https://music.apple.com/de/song/maschinen/1879494421"} 
        appleMusicPresaveLink={undefined}
        youtubeMusicLink={"https://music.youtube.com/watch?v=BecBi573Uro&si=Okq7bSs72YZH-K0D"}
        youtubeLink={"https://youtu.be/nHW8hw5Y0e8"}
        tidalLink={"https://tidal.com/album/492453683/track/492453685"}
        amazonMusicLink={"https://www.amazon.de/dp/B0GJF353YR"}
        bandcampLink={"https://mondwild.bandcamp.com/track/maschinen"}
        releaseDate={"2026-02-13T00:00:00+01:00"}/>
    );
}